var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 343,
    viewBox: "0 0 303 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M302.572 62.3789C299.533 140.216 297.513 182.621 290.938 246.624C285.376 271.099 279.492 281.226 260.399 288.134C184.361 309.838 131.02 327.216 69.1636 342.024C43.9788 341.42 35.0001 334.859 26.9901 320.177C13.3027 268.391 10.7428 211.689 0.813416 139.573C-0.517548 111.761 4.98779 100.465 26.9901 88.5957C107.598 54.7465 224.769 8.48892 224.769 8.48892C224.769 8.48892 247.166 -2.28758 260.399 0.478247C275.874 5.33123 282.607 10.7047 290.938 21.5973C300.549 34.4498 303.067 43.3867 302.572 62.3789Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightWhite);
export default __webpack_public_path__ + "static/media/RightWhite.af1e24cb280fcbe13a9a9b6d1d5ab2a3.svg";
export { ForwardRef as ReactComponent };